export const MUSIC_SUPERVISION = 'music_supervision'
export const POST_PRODUCTION = 'post_production'
export const LABEL = 'label'
export const PUBLISHER = 'publisher'
export const SYNC_AGENCY_REP = 'sync_agency_rep'
export const PRODUCTION_MUSIC_LIBRARY = 'production_music_library'
export const MUSIC_CREATOR = 'music_creator'
export const ARTIST_MANAGEMENT = 'artist_management'
export const PROMOTIONS = 'promotions'
export const RADIO_STATION = 'radio_station'
export const PODCAST_CONTENT_CREATION = 'podcast_content_creation'
export const OTHER = 'other'
export type BusinessTypes =
  | typeof MUSIC_SUPERVISION
  | typeof POST_PRODUCTION
  | typeof LABEL
  | typeof PUBLISHER
  | typeof SYNC_AGENCY_REP
  | typeof PRODUCTION_MUSIC_LIBRARY
  | typeof MUSIC_CREATOR
  | typeof ARTIST_MANAGEMENT
  | typeof PROMOTIONS
  | typeof RADIO_STATION
  | typeof PODCAST_CONTENT_CREATION
  | typeof OTHER
  | null
export const BUSINESS_TYPES = [
  MUSIC_SUPERVISION,
  POST_PRODUCTION,
  LABEL,
  PUBLISHER,
  SYNC_AGENCY_REP,
  PRODUCTION_MUSIC_LIBRARY,
  MUSIC_CREATOR,
  ARTIST_MANAGEMENT,
  PROMOTIONS,
  RADIO_STATION,
  PODCAST_CONTENT_CREATION,
  OTHER,
] as const
export const BUSINESS_TYPES_LABEL_MAP = {
  [MUSIC_SUPERVISION]: 'Music Supervision',
  [POST_PRODUCTION]: 'Post-production',
  [LABEL]: 'Label',
  [PUBLISHER]: 'Publisher',
  [SYNC_AGENCY_REP]: 'Sync Agency / Rep',
  [PRODUCTION_MUSIC_LIBRARY]: 'Production Music Library',
  [MUSIC_CREATOR]: 'Music Creator',
  [ARTIST_MANAGEMENT]: 'Artist Management',
  [PROMOTIONS]: 'Promotions',
  [RADIO_STATION]: 'Radio Station',
  [PODCAST_CONTENT_CREATION]: 'Podcast Content Creation',
  [OTHER]: 'Other',
} as const satisfies Record<Exclude<BusinessTypes, null>, string>
